module.exports = __webpack_public_path__ + "img/ArmadoGruposEnActivacion.510b7190.svg";